import { Component, Input } from '@angular/core';
import { IaithService } from 'src/app/craidd/gwasanaethau/iaith/iaith.service';
import { Gwallau } from 'src/app/craidd/modelau/gwall';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-gwall-rhestr',
    templateUrl: './gwall-rhestr.component.html',
    styleUrls: ['./gwall-rhestr.component.scss'],
    imports: [TranslatePipe]
})
export class GwallRhestrComponent {
  gwallauWediFformatio: Array<string> = [];

  @Input() gwallUnigol: string;

  @Input()
  set gwallau(rhestrGwallau: Gwallau) {
    //    this.gwallauWediFformatio = Object.keys(rhestrGwallau.errors || {})
    //          .map(key => `${key} ${rhestrGwallau.errors[key]}`);

    this.gwallauWediFformatio = Object.keys(rhestrGwallau.errors || {})
      .map(key => `${this.nolIaithTestun(rhestrGwallau.errors[key])}`);
  }

  get rhestrGwallau() { return this.gwallauWediFformatio; }

  constructor(private iaithService: IaithService) {

  }

  nolIaithTestun(testun: string): string {
    return this.iaithService.nolTestun(testun)[testun];
  }
}
